// totalStep="1" (질문 1개)- 1.이름&번호
// totalStep="2" (질문 2개)- 1.임플란트 갯수, 2.이름&번호
// numberColor - #0854fc(밝은 파란색),#0824a4(남색), #3f8c58(짙은 녹색),#18646c(청록색)
// qOptionColor - blue, green, teal

import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { handleFormSubmit } from "../handlers/formHandlers";
import PhoneNumberInput from "../components/PhoneNumberInput";
import BenefitPeriod from "../components/BenefitPeriod";
import PrivacyPolicyAgree from "../components/PrivacyPolicyAgree";
import { validateName, validatePhoneNumber } from "../utils/validation";
import {
  options,
  phoneFirstOptions,
  prohibitedWords,
} from "../utils/dummyData";

import "./randingStyle1.scss";
import SelectEvents from "../components/SelectEvents";
import PrivacyContent from "./PrivacyContent";

function RandingStyle1({
  urlCode,
  urlCodeSettingId,
  totalStep,
  changedIMG,
  img1Path,
  img2Path,
  img3Path,
  numberColor,
  qOptionColor,
  keepBTN,
  postBTN,
  companyName,
  privacyCompanyName,
  footerPath,
  articleOption,
  articleOptionColor,
  apiUrl,
  eventsOption,
  treatments,
  privacyMessage,
  addStyle,
  kakaotalk,
  carrotTag,
}) {
  const navigate = useNavigate();

  // 상태 관리.
  const [selectedValue, setSelectedValue] = useState(null); // 선택된 값을 저장할 상태

  const [name, setName] = useState("");

  const [isSubmitting, setIsSubmitting] = useState(false); // 버튼 상태 관리
  const [phoneNumber, setPhoneNumber] = useState({
    first: "",
    second: "",
    third: "",
  });

  const [selectedOption, setSelectedOption] = useState("");
  const [currentStep, setCurrentStep] = useState(1);
  const [isAgreed, setIsAgreed] = useState(false);
  const [isPrivacyPolicyModal, setIsPrivacyPolicyModal] = useState(false);
  const [submitCount, setSubmitCount] = useState(0);

  // 유효성 검사
  const validateInput = () => {
    return (
      validateName(name, prohibitedWords) && validatePhoneNumber(phoneNumber)
    );
  };

  // 이벤트 핸들러
  const handlePhoneNumberChange = (e) => {
    const { name, value } = e.target;
    const numericValue = value.replace(/[^0-9]/g, "");

    setPhoneNumber((prev) => ({
      ...prev,
      [name]: numericValue,
    }));
  };

  const handleSelectImplant = (option) => {
    setSelectedOption(option);
    console.log(option);
  };

  const nextStep = () => {
    if (currentStep < 2) setCurrentStep(currentStep + 1);
  };

  const togglePrivacyPolicyModal = () => {
    setIsPrivacyPolicyModal(!isPrivacyPolicyModal);
  };

  const handleSubmit = () => {
    handleFormSubmit({
      name,
      phoneNumber,
      selectedOption,
      isAgreed,
      submitCount,
      setSubmitCount,
      validateInput,
      urlCode,
      urlCodeSettingId,
      navigate,
      setIsSubmitting,
      apiUrl,
      // 이벤트 복수 세팅
      selectedValue,
      kakaotalk,
      carrotTag,
    });
  };

  return (
    <div className="form-container">
      {eventsOption && (
        <SelectEvents
          selectedValue={selectedValue}
          setSelectedValue={setSelectedValue}
          treatments={treatments}
        />
      )}
      {totalStep == 2 && currentStep === 1 && (
        <div className="step1">
          <img src={img1Path} alt="임플란트 고민중이세요?" />

          <div className="rel">
            {articleOption && (
              <p
                className="notice-limited-event"
                style={articleOptionColor && { color: articleOptionColor }}
              >
                ※{new Date().getMonth() + 1}월 한정 이벤트 입니다※
                <br />
                ※위 이벤트는 조기종료될 수 있습니다※
              </p>
            )}
            {img2Path && (
              <img
                src={img2Path}
                alt="임플란트 최대 비용 혜택 의료법상 49% 최대할인"
              />
            )}
          </div>

          <div className="qBox">
            <div className="qTitle">
              <span style={{ color: numberColor }}>{currentStep}</span>
              <p>
                임플란트 필요한
                <br />
                개수는?
              </p>
            </div>

            <div className="qOptions">
              {options.map((option, index) => (
                <img
                  key={index}
                  src={`${process.env.REACT_APP_CDN_BASE}/images/qOptions/default/${
                    selectedOption === option
                      ? `${qOptionColor || "blue"}/qoption${index + 1}(1)`
                      : `qoption${index + 1}`
                  }.png`}
                  alt={option}
                  onClick={() => handleSelectImplant(option)}
                />
              ))}
            </div>
            <div className="sendBtnBox">
              <img src={keepBTN} alt="계속하기" onClick={nextStep} />
            </div>
          </div>
        </div>
      )}

      {(totalStep == 1 || currentStep === 2) && (
        <div className="step2">
          <img src={img1Path} alt="임플란트 고민중이세요?" />
          <div className="rel">
            {articleOption && (
              <p
                className="notice-limited-event"
                style={articleOptionColor && { color: articleOptionColor }}
              >
                ※{new Date().getMonth() + 1}월 한정 이벤트 입니다※
                <br />
                ※위 이벤트는 조기종료될 수 있습니다※
              </p>
            )}
            {img2Path && (
              <img
                src={changedIMG ? changedIMG : img2Path}
                alt="임플란트 고민중이세요?"
              />
            )}
          </div>
          <div className="qBox">
            <div className="qTitle">
              <span style={{ color: numberColor }}>{currentStep}</span>
              <p>
                귀하의 성함과 연락처를
                <br />
                입력해주세요.
              </p>
            </div>
            {/* 전송폼 세분화 */} {/* 전송폼 세분화 */} {/* 전송폼 세분화 */}
            {/* 전송폼 세분화 */} {/* 전송폼 세분화 */} {/* 전송폼 세분화 */}
            <form
              className="formBox"
              onSubmit={(e) => {
                e.preventDefault(); // 기본 제출 동작 방지
                handleSubmit(); // 기존 handleSubmit 호출
              }}
            >
              <div className="formField">
                <label htmlFor="name">이름</label>
                <input
                  type="text"
                  id="name"
                  maxLength="10"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  required // 필수 입력 필드
                />
              </div>

              <PhoneNumberInput
                phoneNumber={phoneNumber}
                phoneFirstOptions={phoneFirstOptions}
                handlePhoneNumberChange={handlePhoneNumberChange}
              />
              <p className="benefitInfo">
                <BenefitPeriod />
                <br />
                이벤트 대상자 : 해당 매체 이용자
              </p>
              <PrivacyPolicyAgree
                isAgreed={isAgreed}
                setIsAgreed={setIsAgreed}
                togglePrivacyPolicyModal={togglePrivacyPolicyModal}
                privacyMessage={privacyMessage}
              />

              {isPrivacyPolicyModal && (
                <div
                  className="modalOverlay"
                  onClick={togglePrivacyPolicyModal}
                >
                  <div
                    className="privacyPolicyContent"
                    onClick={(e) => e.stopPropagation()}
                  >
                    <PrivacyContent companyName={privacyCompanyName || companyName || "수집주체명"} />
                  </div>
                </div>
              )}
              <button
                type="submit"
                className="sendBtnBox"
                disabled={isSubmitting}
              >
                <img src={postBTN} alt="신청하기" />
              </button>
            </form>
          </div>
        </div>
      )}
      <div className="footer">
        {footerPath && <img src={footerPath} alt="푸터" />}
      </div>
    </div>
  );
}

export default RandingStyle1;
